import Reflux from 'reflux'
import axios from 'axios'

import AppActions from '~/actions/app.js'
import AuthActions from '~/actions/auth.js'

import apiUtils from '../helper/api.js'


export default class AuthStore extends Reflux.Store {
	constructor() {
		super()

		this.listenables = AuthActions

		this.state = {
			authenticated: false,
			failed: false,
			username: '',
			user: {}
		}

		const checkToken = window.sessionStorage.getItem('token')
		const checkUserID = window.sessionStorage.getItem('userId')
		const checkUserName = window.sessionStorage.getItem('userName')

		// if we find a cookie token, then let's use it
		if (checkToken !== null) {
			this.state.user.id = checkToken
			this.state.authenticated = true

			if (checkUserID !== null) {
				this.state.user.userId = checkUserID
			}
			if (checkUserName !== null) {
				this.state.username = checkUserName
			}
		}
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	login(email, password) {
		axios.post(
			`${apiUtils.getApiURL()}/Users/login`,
			{
				email,
				password
			}
		)
			.then(
				(response) => {
					// add the token from the call
					window.sessionStorage.setItem('token', response.data.id)
					window.sessionStorage.setItem('userId', response.data.userId)

					this.setState(
						{ authenticated: true, failed: false, user: response.data }
					)

					// set up the authentication header for all future requests
					axios.defaults.headers.common.Authorization = response.data.id;

					AppActions.hideLoginModal()

					axios.get(
						`${apiUtils.getApiURL()}/Users/${response.data.userId}?access_token=${response.data.id}`
					)
						.then((responseInner) => {
							window.sessionStorage.setItem('userName', responseInner.data.username)

							this.setState({ username: responseInner.data.username })
						})
				}
			)
			.catch(() => this.setState({ authenticated: false, failed: true }))
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	logout() {
		this.setState({
			authenticated: false,
			failed: false,
			username: ''
		})
	}
}



// WEBPACK FOOTER //
// ./src/stores/auth.js